export default __webpack_public_path__ + "src/assets/icn-diversification.a6fd3425fc4aa633f235abeac1f1b362.svg";